/* eslint-disable @typescript-eslint/no-explicit-any */
import styled from 'styled-components';

interface WorkspaceInputProps {
  editing: string;
  inputlength: any;
}

interface WorkspaceButtonProps {
  active: any;
}

interface WorkspaceContainerProps {
  active: any;
}

interface DynamicRowProps {
  rowheight: string;
}

interface DropDownWrapperProps {
  bgColor: string;
  textColor?: string;
}

export const WorkspaceInputStyled = styled.input<WorkspaceInputProps>`
    border: none;
    border-bottom: 2px solid rgb(181, 181, 181);
    outline: none !important;
    text-align: left;
    font-size: 14px;
    line-height: 20px;
    padding: 0;
    margin: 0;
    background: transparent;

    width: ${(props) =>
    props.editing === 'true'
      ? `${(props.inputlength + 4) * 7}px`
      : '100%'};
    min-width: 60px;
    max-width: 120px;
`;

export const WorkspaceButtonBarStyled = styled.div`
    display: flex;
    margin-top: 2px;
    margin-left: 0px;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    overflow: hidden;
`;

export const WorkspaceButtonContainerStyled = styled.div<WorkspaceButtonProps>`
  flex: ${({ active }) => (active ? '0 0 auto' : '0 1 150px')};
  width: ${({ active }) => (active ? 'auto' : '100%')};
  min-width: ${({ active }) => (active ? '150px' : '60px')};
  max-width: ${({ active }) => (active ? 'unset' : '150px')};
  background-color: ${({ active }) => (active ? 'white' : '#F1F5F9')};
  border: ${({ active }) => (active ? '1px solid #DFDFDF' : '1px solid #CBD5E1')};
  border-bottom: ${({ active }) => (active ? 'none' : '1px solid #DFDFDF')};
  margin: 5px 2px 0 0;
  padding: ${({ active }) => (active ? '3px 12px' : '2px 10px')};
  height: ${({ active }) => (active ? '26px' : '23px')};
  border-radius: ${({ active }) => (active ? '6px 6px 0 0' : '6px')};
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: default !important;
  position: relative;
  overflow: hidden;

  &:hover {
    flex: 0 0 auto;
    width: auto;
    min-width: 150px;
    max-width: unset;
    padding: 3px 12px;
    border-radius: ${({ active }) => (active ? '6px 6px 0 0' : '6px 6px 6px 6px')};
    background-color: white !important;
    .workspace-tab-label::after {
      display: none;
    }
  }


  .workspace-button {
    color: grey;
    background-color: transparent;
    border: none;
    cursor: pointer;
    font-size: 1rem;
  }

  .workspace-button.e-icons::before {
    color: rgb(180, 180, 180) !important;
    cursor: pointer;
  }

  .workspace-button.e-icons {
    padding: 4px;
    font-size: 10px;

    &::before {
      margin: 0 !important;
    }
  }

  .e-drag-and-drop,
  &:hover .e-drag-and-drop.disabled,
  &[active="1"] .e-drag-and-drop.disabled,
  &:hover .workspace-button.e-icons:disabled::before,
  &[active="1"] .workspace-button.e-icons:disabled::before {
    color: rgb(200, 200, 200) !important;
    cursor: default !important;
  }

  &:hover .e-drag-and-drop,
  &[active="1"] .e-drag-and-drop:not(.disabled),
  &:hover .workspace-button.e-icons::before,
  &[active="1"] .workspace-button.e-icons:not(disabled)::before {
    color: rgb(100, 100, 100) !important;
  }

  .workspace-button.e-icons {
    font-size: 10px;
    margin-left: 6px;
  }

  .workspace-tab-label {
    flex: 1 1 auto;
    margin-left: 4px;
    margin-top: ${({ active }) => (active ? '-1px' : '2px')};
    color: var(--basic) !important;
    font-size: 14px;
    line-height: 20px;
    text-align: left;
    position: relative;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-right: 12px;

    &::after {
      content: "";
      position: absolute;
      top: 0;
      right: 0;
      width: 30px;
      height: 100%;
      background: ${({ active }) =>
    active
      ? 'linear-gradient(to right, transparent, white)'
      : 'linear-gradient(to right, transparent, #F1F5F9)'};
      pointer-events: none;
      transition: background 0.2s ease;
    }
  }

  &:hover .workspace-tab-label::after {
    background: ${({ active }) =>
    active
      ? 'linear-gradient(to right, transparent, white)'
      : 'linear-gradient(to right, transparent, #E2E8F0)'};
  }

  .workspace-tab-label::after {
    display: ${({ active }) => (active ? 'none' : 'block')};
  }

  /* Tabs extrem klein: nur "..." anzeigen */
  &.too-small .workspace-tab-label {
    text-overflow: clip;
  }

  &.too-small .workspace-tab-label::before {
    content: "...";
  }

  &.too-small .workspace-tab-label span {
    display: none;
  }
`;

export const WorkspaceContentContainerStyled = styled.div<WorkspaceContainerProps>`
    height: calc(100vh - 0px);
    width: calc(100% - 12px);
    display: ${({ active }) => (active ? null : 'none')};

    .e-control.e-btn,
    .e-dropdown-btn,
    .e-tbar-button {
      background-color: var(--primaryColor) !important;
      border: 1px solid #D3D3D3 !important;
      border-radius: 12px !important;
      box-shadow: none !important;
      color: var(--primaryContrast) !important;
    }

    .e-btn.e-icons,
    .e-dropdown-btn .e-icons,
    .e-tbar-button.e-icons,
    .e-tbar-btn .e-icons{
      color: var(--primaryContrast) !important;
    }

    .e-tbar-button:hover,
    .e-tbar-button:active,
    .e-dropdown-btn:hover,
    .e-dropdown-btn:active,
    .e-control.e-btn:hover,
    .e-control.e-btn:active {
      background-color: color-mix(in srgb, var(--primaryColor) 80%, black 20%) !important;
    }

    .code-cell .e-control.e-btn,
    .right.item .e-control.e-btn {
      padding: 3px 0px 0px 0px !important;
      border-radius: 4px;
      margin: 0px 3px 0px 3px;
      height: 21px;
      width: 21px;
    }

    .code-cell .e-control.e-btn .e-icons,
    .right.item .e-control.e-btn .e-icons {
      font-size: 13px !important;
    }

    .code-cell .e-control.e-btn.e-disabled,
    .code-cell .e-control.e-btn.e-disabled *,
    .right.item .e-control.e-btn.e-disabled,
    .right.item .e-control.e-btn.e-disabled * {
      cursor: default !important;
    }
`;

export const InnerColumnStyled = styled.div`
    height: 100%;
`;

export const DynamicRowStyled = styled.div<DynamicRowProps>`
    margin: 2px;
    border-radius: 3px;
    display: flex;
    flex-direction: column;
    height:  ${props => props.rowheight};

    & Form {
      height: 100%;
    }
`;

export const StyledDropDownWrapper = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'bgColor' && prop !== 'textColor',
})<DropDownWrapperProps>`
  display: flex;
  margin-left: 1rem;
  margin-right: 1rem;
  background-color: ${({ bgColor }) => bgColor || 'transparent'} !important;
  border-radius: 8px !important;
  max-height: 22px !important;

  .e-dropdown-btn {
    position: relative;
    background-color: ${({ bgColor }) => bgColor || 'transparent'} !important;
    color: ${({ bgColor }) =>
    `color-mix(in srgb, white 90%, ${bgColor} 10%)`} !important;
    border: 1px solid #CBD5E1;
    font-size: 0.875rem;
    border-radius: 8px !important;

    display: flex !important;
    align-items: center;
    justify-content: flex-start;
    gap: 6px;

    height: 23px;            /* Tabs inaktiv */
    line-height: 20px;
    min-width: 50px !important;
    max-width: 160px !important;

    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;

    padding: 2px 15px 0 15px;

    &::after {
      content: "";
      position: absolute;
      top: 0;
      right: 0;
      width: 40px;
      height: 100%;
      background: linear-gradient(
        to right,
        transparent 60%,
        ${({ bgColor }) => bgColor || 'transparent'}
      );
      pointer-events: none;
    }
}

  .e-icons {
      font-size: 14px;
      flex-shrink: 0;
      position: relative;
      z-index: 1; 
  }

  .e-icon-right {
    display: none !important;
  }
`;


